import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CorporateService } from 'src/app/services/corporate.service';
import { Location } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
@Component({
    selector: 'app-confirm-removediscount',
    templateUrl: './confirm-removediscount.component.html',
    styleUrls: ['./confirm-removediscount.component.css']
})
export class ConfirmRemoveDiscountComponent implements OnInit {
    title: string;
    confirmationMessage: string;
    type: any;
    api_error: any;
    api_success: any;
    disableConfirmbtn = false;
    btndisabled  = false;
    constructor(public dialogRef: MatDialogRef<ConfirmRemoveDiscountComponent>,
        private matDialogRef: MatDialogRef<any>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private router: Router, private activatedRoute: ActivatedRoute,
        private corporateService: CorporateService,
        private _location: Location,
        private location: Location,
    ) {
    }
    ngOnInit() {
        this.title = this.data['title'];
        this.type = this.data['type'];
        this.confirmationMessage = this.title;
    }
    onConfirm() {
        this.dialogRef.close();
    }
    goBacktoList() {
        this.location.back();
        // this.router.navigate(['../list'], { relativeTo: this.activatedRoute });
      }
}
